import React,{useState} from "react";
import { Link } from "react-router-dom";

import bg1 from "../assets/images/bg/nondiscrimination1.webp"
import cta from "../assets/images/cta.jpg"
import acceptance from "../assets/images/acceptance.jpg"

import NavbarTwo from "../components/navbar/navbarTwo"
import ClientTwo from "../components/client/clientTwo";
import Partners from "../components/partners";
import Team from "../components/team";
import FooterThree from "../components/footer/footerThree";
import ScrollTop from "../components/scrollTop";
import about14 from "../assets/images/about14.jpg";
import ModalVideo from 'react-modal-video';
import '../../node_modules/react-modal-video/css/modal-video.css';

import {AiOutlineCheckCircle, FiAirplay, LiaReact, FiUsers,FiArrowRight} from '../assets/icons/vander'
import CountUp from 'react-countup';

export default function AboutUs(){
    const [isOpen, setOpen] = useState(false);
    const aboutData = [
        {
            icon:FiAirplay,
            title:'Developing strategy',
            desc:'It is said that song composers of the past used dummy texts as lyrics when writing to sing with the melody.'
        },
        {
            icon:LiaReact,
            title:'Blazing performance',
            desc:'It is said that song composers of the past used dummy texts as lyrics when writing to sing with the melody.'
        },
        {
            icon:FiUsers,
            title:'Customer satisfaction',
            desc:'It is said that song composers of the past used dummy texts as lyrics when writing to sing with the melody.'
        },
    ]
    const counterData = [
        {
            start:'0',
            end:'5458',
            title:'Investment Projects'
        },
        {
            start:'0',
            end:'15',
            title:'Years of Experience'
        },
        {
            start:'0',
            end:'54',
            title:'Offices in the World'
        },
        {
            start:'0',
            end:'214',
            title:'Successful Cases'
        },
    ]
    return(
        <>
        <NavbarTwo navClass="defaultscroll sticky" manuClass="navigation-menu nav-right nav-light"/>

        <section className="bg-half-170 d-table w-100" style={{backgroundImage:`url(${bg1})`, backgroundPosition:'center'}}>
            <div className="bg-overlay bg-gradient-overlay"></div>
            <div className="container">
                <div className="row mt-5 justify-content-center">
                    <div className="col-12">
                        <div className="title-heading text-center">
                            <h5 className="heading fw-semibold mb-0 page-heading text-white title-dark">Statement of Nondiscrimination</h5>
                            <small className="text-white-50 mb-1 fw-medium text-uppercase mx-auto">There are moments in life when doing nothing <br></br>quietly sides with everything that’s wrong.</small>
                        </div>
                    </div>
                </div>

                <div className="position-middle-bottom">
                    <nav aria-label="breadcrumb" className="d-block">
                        <ul className="breadcrumb breadcrumb-muted mb-0 p-0">
                            <li className="breadcrumb-item"><Link to="/">Home</Link></li>
                            <li className="breadcrumb-item active" aria-current="page">Statement of Nondiscrimination</li>
                        </ul>
                    </nav>
                </div>
            </div>
        </section>
        <section className="section">
            <div className="container">
                <div className="row align-items-center">
                    

                    <div className="row align-items-center mt-5 mb-5">
                    <div className="col-lg-5 col-md-6">
                        <img src={about14} className="img-fluid rounded shadow" alt=""/>
                    </div>
                    <div className="col-lg-7 col-md-6 mt-4 pt-2 mt-sm-0 pt-sm-0">
                        <div className="section-title ms-lg-5">
                        <h3 className="title mb-3">Statement of Nondiscrimination</h3>
                        <p className="text-muted2">Inclusive Family Insurance is committed to fostering a welcoming, equitable, and accessible environment for all individuals and families. <b>We believe that everyone deserves dignity, respect, and access to financial security, regardless of their background or circumstances.</b> <br></br><br></br>
                        Discriminatory practices of any kind are antithetical to our mission, vision, and values. These include, but are not limited to, discrimination based on race, color, ethnicity, national origin, religion, sex, gender, gender identity, gender expression, sexual orientation, marital status, pregnancy, parental status, disability, age, genetic information, military or veteran status, immigration status, socioeconomic status, housing status, or any other characteristic protected under applicable laws. Regardless of federal, state and local policy shifts, Inclusive Family Insurance remains steadfast in its commitment to strive for equity, fairness, and insurance for all.</p>
                        </div>
                    </div>
                </div>
                </div>
            </div>

            
        </section>
        <FooterThree/>
        <ScrollTop/>
        </>
    )
}